import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAgpUJiKZbfdhPpQKUMI29CHfK3f8mk8Tg",
  authDomain: "lovers-df45a.firebaseapp.com",
  projectId: "lovers-df45a",
  messagingSenderId: "498679323607",
  appId: "1:498679323607:web:330b543e26613e735f0992"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export default app;

let _messaging: any = null;

export async function getMessagingInstance() {
  if (_messaging) return _messaging;
  try {
    const { getMessaging, isSupported } = await import('firebase/messaging');
    const ok = await isSupported();
    if (!ok) return null;
    _messaging = getMessaging(app);
    return _messaging;
  } catch {
    return null;
  }
}
